import React from 'react'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'
import get from 'lodash/get'
import rehypeReact from 'rehype-react'
import ObjectData from '../components/ObjectData'
import Period from '../components/Period'
import ToggleTip from '../components/ToggleTip'

class TimelineTemplate extends React.Component {
  render() {
    const resource = this.props.data.markdownRemark
    const siteTitle = get(this.props, 'data.site.siteMetadata.title')

    const renderAst = new rehypeReact({
      createElement: React.createElement,
      components: { 'object-block': ObjectData, 'toggle-tip': ToggleTip },
    }).Compiler

    return (
      <div id="main">
        <Helmet>
          <title>{`${resource.frontmatter.title} | ${siteTitle}`}</title>
          <html lang="en" />
        </Helmet>

        <div id="one">
          <h1>{resource.frontmatter.title}</h1>

          {renderAst(resource.htmlAst)}
        </div>

        <div id="two">
          <Period periods={resource.frontmatter.periods} />
        </div>
      </div>
    )
  }
}

export default TimelineTemplate

export const timelinePageQuery = graphql`
  query TimelineByPath($path: String!) {
    site {
      siteMetadata {
        title
        author
      }
    }
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      id
      htmlAst
      frontmatter {
        title
        category
        path
        country
        periods {
          id
          title
          body
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/timeline.js